var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { LanguageService } from 'common/services/LanguageService';
import { AppLinkHelper } from 'packages/utilities/AppLinkHelper';
import { container } from 'tsyringe';
var AppLink = /** @class */ (function (_super) {
    __extends(AppLink, _super);
    function AppLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.languageService = container.resolve(LanguageService);
        _this.appLinkHelper = container.resolve(AppLinkHelper);
        _this.linkProperties = null;
        return _this;
    }
    AppLink.prototype.getLinkProperties = function () {
        var route = typeof this.to === 'string' ? { path: this.to } : this.to;
        var url = route.path;
        if (url && url.match(/^(http(s)?|ftp):\/\//)) {
            if (route.hash) {
                return {
                    is: 'a',
                    href: url + "?" + this.appLinkHelper.convertQueryParameters(route.query) + route.hash,
                };
            }
            return {
                is: 'a',
                href: url + "?" + this.appLinkHelper.convertQueryParameters(route.query),
            };
        }
        // remove type warnings for active-class being array
        var attr = this.$attrs;
        if (Array.isArray(attr['active-class'])) {
            attr['active-class'] = attr['active-class'].join(' ');
        }
        return __assign({ is: 'router-link', to: route }, attr);
    };
    AppLink.prototype.updateLinkProperties = function () {
        this.linkProperties = this.getLinkProperties();
    };
    AppLink.prototype.languageUpdated = function () {
        this.linkProperties = this.getLinkProperties();
    };
    var _a;
    __decorate([
        Prop({ type: [String, Object], required: true }),
        __metadata("design:type", Object)
    ], AppLink.prototype, "to", void 0);
    __decorate([
        Watch('to', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AppLink.prototype, "updateLinkProperties", null);
    __decorate([
        Watch('languageService.language', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AppLink.prototype, "languageUpdated", null);
    AppLink = __decorate([
        Component
    ], AppLink);
    return AppLink;
}(Vue));
export default AppLink;
